import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets()  {
    return ["trigger"]
  }

  show(e) {
    const dropdown = new bootstrap.Dropdown(this.triggerTarget)
    dropdown.show()
  }

  hide(e) {
    const dropdown = bootstrap.Dropdown.getInstance(this.triggerTarget)

    setTimeout(() => {
      dropdown.hide()
      this.triggerTarget.blur()
    }, 150);
  }

  // disable the click
  prevent(e) {
    e.preventDefault()
  }
}
